'use strict';
var arraySlice = require('../internals/array-slice');

// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
  return new this(arraySlice(arguments));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/collection-of.js
// module id = VJQP
// module chunks = 15